import React, { useState, useEffect } from 'react';

export default function Countdown({ countdownEnd, setIsBannerHidden, color }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    total: 0
  });

  const calculateTimeLeft = target => {
    const now = new Date().getTime();
    const targetTime = new Date(target).getTime();
    const difference = targetTime - now;

    if (difference <= 0) {
      setIsBannerHidden(true);
      return { days: 0, hours: 0, minutes: 0, seconds: 0, total: 0 };
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds, total: difference };
  };

  useEffect(() => {
    setTimeLeft(calculateTimeLeft(countdownEnd));

    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft(countdownEnd));
    }, 1000);

    return () => clearInterval(interval);
  }, [countdownEnd]);

  return (
    <div
      className="flex flex-wrap justify-center gap-1 font-semibold uppercase text-white"
      style={{
        color
      }}
    >
      <div className="w-5 text-center">
        {String(timeLeft.days).padStart(2, '0')}
      </div>
      <div>:</div>
      <div className="w-5 text-center">
        {String(timeLeft.hours).padStart(2, '0')}
      </div>
      <div>:</div>
      <div className="w-5 text-center">
        {String(timeLeft.minutes).padStart(2, '0')}
      </div>
      <div>:</div>
      <div className="w-5 text-center">
        {String(timeLeft.seconds).padStart(2, '0')}
      </div>
    </div>
  );
}
